var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/category-content-slots.j2"] = require( "macros/category-content-slots.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-primary-content-slot.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
var t_1;
t_1 = "PAGE_PRIMARY";
frame.set("categoryContentContext", t_1, true);
if(frame.topLevel) {
context.setVariable("categoryContentContext", t_1);
}
if(frame.topLevel) {
context.addExport("categoryContentContext", t_1);
}
env.getTemplate("macros/category-content-slots.j2", false, "category/templates/category-primary-content-slot.j2", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
t_2.getExported(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
context.setVariable("contentSlot", t_2);
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"primaryContentSlot")) {
output += "<div class=\"dom-category__primary-content-slot\" data-qa-primary-content-slot>\n    ";
output += runtime.suppressValue((lineno = 9, colno = 35, runtime.callWrap(runtime.memberLookup((t_2),"displayContentSlot"), "contentSlot[\"displayContentSlot\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"primaryContentSlot")])), env.opts.autoescape);
output += "\n</div>";
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-primary-content-slot.j2"] , dependencies)